/**
 * Checks if an element is entirely visible in the viewport.
 * @param el The element to check
 * @returns true if the element is entirely visible in the viewport, false otherwise
 */
export const isElementInViewport = (el: Element): boolean => {
	const rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};
